import React, { useEffect, useRef, useState } from "react";
import Cloudbannerall from "./Cloudbannerall";
import NewFooter from "./NewFooter";
import MainPageRestaurantCards from "./MainPageRestaurantCards";

const HomePage = () => {
  const scrollContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  // For toggle buttons
  const [showMore, setShowMore] = useState(false);
  const [showGallery, setShowGallery] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const scrollSpeed = 2;
    const scrollInterval = 30;

    const interval = setInterval(() => {
      if (!isHovered && scrollContainer.scrollHeight > scrollContainer.clientHeight) {
        scrollContainer.scrollTop += scrollSpeed;

        if (
          scrollContainer.scrollTop + scrollContainer.clientHeight >=
          scrollContainer.scrollHeight
        ) {
          scrollContainer.scrollTop = 0;
        }
      }
    }, scrollInterval);

    return () => clearInterval(interval);
  }, [isHovered]);

  return (
    <div style={styles.container}>
      <style>{`
        @media (max-width: 999px) {
          .right-panel {
            display: none !important;
          }
        }
      `}</style>

      <div style={{ marginTop: "0px" }} className="webinarbanner-first">
        <div style={styles.pageContainer}>

          {/* Full-width banner */}
          <div style={styles.bannerWrapper}>
            <Cloudbannerall />


          </div>

          {/* Conditional rendering for Know More */}
          {showMore && (
            <div style={{ marginTop: "20px" }}>
              {/* <MainAbout/>
              <MainLeader />
              <MainMission /> */}
            </div>
          )}

          {/* Conditional rendering for Gallery */}
          {showGallery && (
            <div style={{ marginTop: "20px" }}>
              {/* <MainGallery/> */}
            </div>
          )}
        </div>
        <MainPageRestaurantCards />
        <NewFooter />
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    margin: 0,
    padding: 0,
    overflowX: "hidden",
    boxSizing: "border-box",
  },
  pageContainer: {
    width: "100%",
    scrollBehavior: "smooth",
  },
  bannerWrapper: {
    width: "100%",
    margin: 0,
    padding: 0,
  },
  greenButton: {
    padding: "10px 20px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "green",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
    zIndex: 1000,
  },
  blueButton: {
    padding: "10px 20px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "blue",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
    zIndex: 1000,
  },
};

export default HomePage;
